var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCgu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.999 16c-.001 7.732-6.269 14-14 14-7.732 0-14-6.268-14-14S8.268 2 16 2c7.731 0 13.999 6.268 13.999 14zM9.323 9.887h2.04v-.913c.515-.148 2.144-.296 3.153 0v.913h3.36v-.913c.515-.148 2.144-.296 3.153 0v.913h1.862l3.166 8.787c-.35 1.873-2.49 3.957-3.468 4.399l-3.375-3.666-6.237-.012-3.259 3.678c-1.548-.768-3.573-3.305-3.573-4.4l3.177-8.786zm7.02 4.946a2.456 2.456 0 0 1 2.455-2.456 2.463 2.463 0 0 1 2.454 2.456 2.456 2.456 0 0 1-2.455 2.455 2.464 2.464 0 0 1-2.457-2.455zm2.57-.932c0 .444.362.816.816.816.453 0 .826-.36.814-.814a.817.817 0 0 0-.814-.815.817.817 0 0 0-.815.814zm-5.505-1.523a2.456 2.456 0 1 0 2.455 2.456 2.44 2.44 0 0 0-2.456-2.456zm.942 2.34a.817.817 0 0 1-.815-.816c0-.452.373-.813.815-.813.454 0 .814.372.814.814a.81.81 0 0 1-.814.816z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCgu);
export default __webpack_public_path__ + "static/media/CGU.360700ed2cd499a09d02e1f5f90651ea.svg";
export { ForwardRef as ReactComponent };